import { Modal } from '@/shared/ui/modal/Modal';
import styles from './UserCoursesAddModal.module.scss'
import { UserCursesList } from '../user-curses-list/UserCursesList';
import { coursesStore } from '@/entities';

interface Props {
  isOpen: boolean,
  onClose: () => void,
  id: string,
  courseId?: string,
}

const UserCoursesAddModal = ({isOpen, onClose, id, courseId}: Props) => {
  const contentCourses = coursesStore((state) => state.contentCoursesList);
  return (
    <Modal
      active={isOpen}
      handleClose={onClose}
      classContaner={styles.container}
    >
      <header className={styles.headerTable}>
        <section className={styles.headerLeftSide}>
          
          <h1 className={styles.modalTitle}>Добавить курс</h1>
        </section>
        <button title="Закрыть" onClick={onClose} className={styles.modalClose}>
          x
        </button>
      </header>
      <UserCursesList userId={id} contentCourses={contentCourses} {...(courseId && {courseId})}/>
    </Modal>
  );
};

export default UserCoursesAddModal;